import {defineStore} from 'pinia'
import {ref} from 'vue'
import axios from "axios";
import Utility from "../vue/Utility";

export const useWishlistStore = defineStore('WishlistStore', () => {
    const wishlistCount = ref(0)
    const wishes = ref([])
    const productIds = ref([])

    async function addToWishlist(productId) {
        try {
            let r = await axios
                .post('/wishlist/add', {
                        productId: productId
                    }
                )

            setWishlistDataFromServer(r.data)
        } catch (error) {
            Utility.catchError(error)
        }
    }

    async function removeFromWishlist(productId) {
        try {
            let r = await axios
                .post('/wishlist/remove', {
                        productId: productId
                    }
                );

            setWishlistCount(r.data.count)
            setWishes(r.data.wishes)
            setProductIds(r.data.productIds)
        } catch (error) {
            Utility.catchError(error)
        }
    }

    function setWishlistDataFromServer(data) {
        setWishlistCount(data.count)
        setWishes(data.wishes)
        setProductIds(data.productIds)
    }

    function setWishlistCount(value) {
        wishlistCount.value = value
    }

    function setWishes(value) {
        wishes.value = value
    }

    function setProductIds(value) {
        productIds.value = value
    }

    return {
        wishlistCount,
        wishes,
        productIds,
        addToWishlist,
        removeFromWishlist,
        setWishlistDataFromServer
    }
}, {
    persist: true
})
